import { Flex, ScrollArea } from "@mantine/core";
import { ReactNode } from "react";

interface FormModalContentProps {
  children: ReactNode;
  xOffset?: number;
  yOffset?: number;
  yOffsetBottom?: number;
  gap?: number;
  isDesktop?: boolean;
  noScroll?: boolean;
}

const FormModalContent: React.FC<FormModalContentProps> = ({
  children,
  xOffset = 20,
  yOffset = 16,
  yOffsetBottom = 20,
  gap = 20,
  isDesktop = false,
  noScroll = false,
}) => {
  if (noScroll) {
    return (
      <div className="flex flex-col flex-1 min-h-0 overflow-hidden">
        {children}
      </div>
    );
  }

  return (
    <ScrollArea
      scrollbarSize={10}
      scrollbars={"y"}
      type={isDesktop ? "always" : "scroll"}
      px={xOffset}
      h={isDesktop ? "100%" : undefined}
      className="flex flex-col flex-1"
    >
      <Flex
        direction={"column"}
        gap={gap}
        mt={yOffset}
        pb={yOffsetBottom}
        className="min-w-0"
      >
        {children}
      </Flex>
    </ScrollArea>
  );
};

export default FormModalContent;
